import { render, staticRenderFns } from "./batchShelving.vue?vue&type=template&id=22fb9b21&scoped=true&"
import script from "./batchShelving.vue?vue&type=script&lang=js&"
export * from "./batchShelving.vue?vue&type=script&lang=js&"
import style0 from "./batchShelving.css?vue&type=style&index=0&id=22fb9b21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb9b21",
  null
  
)

export default component.exports